export enum PageName {
  ABOUT_US = 'about-us',
  ACCESSIBILITY = 'accessibility-statement',
  ACCOUNT = 'account',
  CHECKOUT = 'checkout',
  COLLECTIONS = 'collections',
  COOKIE_NOTICE = 'cookie-notice',
  CUSTOMER_PASSWORD = 'reset-customer-password',
  LICENSOR_ONBOARDING = 'licensor-onboarding',
  LOGOUT = 'logout',
  MY_UPLOADS = 'my-uploads',
  PRIVACY_POLICY = 'privacy-policy',
  PROFILE = 'profile',
  RECOVER_CUSTOMER = 'recover-customer',
  REFUND_POLICY = 'refund-policy',
  SIGN_IN = 'sign-in',
  SIGN_UP = 'sign-up',
  TERMS = 'terms',
  UPLOAD = 'upload',
}

export const baseRoutes = Object.freeze({
  aboutUs: `/${PageName.ABOUT_US}`,
  accessibilityStatement: `/${PageName.ACCESSIBILITY}`,
  account: `/${PageName.ACCOUNT}`,
  checkout: `/${PageName.CHECKOUT}`,
  collections: `/${PageName.COLLECTIONS}`,
  cookieNotice: `/${PageName.COOKIE_NOTICE}`,
  customerPassword: `/${PageName.CUSTOMER_PASSWORD}`,
  licensorOnboarding: `/${PageName.LICENSOR_ONBOARDING}`,
  logout: `/${PageName.LOGOUT}`,
  myUploads: `/${PageName.MY_UPLOADS}`,
  privacyPolicy: `/${PageName.PRIVACY_POLICY}`,
  profile: `/${PageName.PROFILE}`,
  recoverCustomer: `/${PageName.RECOVER_CUSTOMER}`,
  refundPolicy: `/${PageName.REFUND_POLICY}`,
  resetCustomerPassword: `/${PageName.CUSTOMER_PASSWORD}`,
  root: '/',
  signIn: `/${PageName.SIGN_IN}`,
  signUp: `/${PageName.SIGN_UP}`,
  terms: `/${PageName.TERMS}`,
  upload: `/${PageName.UPLOAD}`,
});

// The user guide (2 Nov): a static file in public/, copied into the build as is and opened in a new tab. Not a route:
// the router never sees it. Its My profile row shows to Platform Admin only, but hiding a link is not access control:
// anyone with this address can read the file.
export const USER_GUIDE_URL = `${process.env.PUBLIC_URL}/user-guide.html`;

export const profileRoutes = Object.freeze({
  information: `/${PageName.PROFILE}/information`,
  orders: `/${PageName.PROFILE}/orders`,
  payment: `/${PageName.PROFILE}/payment`,
});

// The AI-modification screens (SOW Deliverable 4): the buyer's under
// /modifications, the licensor's review under /review. Registered by
// routes/modificationRoutes.tsx; added 2026-10-20, nothing above changes.
export const modificationRoutes = Object.freeze({
  mine: '/modifications',
  newFor: (orderId: string) => `/modifications/new/${orderId}`,
  upload: (id: string) => `/modifications/${id}/upload`,
  detail: (id: string) => `/modifications/${id}`,
  review: '/review',
  reviewDetail: (id: string) => `/review/${id}`,
  // Platform Admin's view-only page of one workflow (23 Oct analysis, H2).
  adminDetail: (id: string) => `/admin/modifications/${id}`,
});

export const checkoutRoutes = Object.freeze({
  payment: `/${PageName.CHECKOUT}/payment`,
  thankyou: `/${PageName.CHECKOUT}/thanks`,
});

export const apiBaseRoutes = Object.freeze({
  auth: 'auth',
});

// The gateway's auth routes. Sign-in, sign-up, recover and reset are Firebase's own calls (27 Oct, the sign-in build,
// step 6); the gateway's legacy routes for them were retired in its step 1.
export const apiAuthRoutes = Object.freeze({
  firebaseSession: `/${apiBaseRoutes.auth}/firebase/session`,
  logout: `/${apiBaseRoutes.auth}/${PageName.LOGOUT}`,
});
